//#region Imports Packages and Libs

import { Component, Prop, Vue } from "vue-facing-decorator";
import Button from "../../components/button.vue";
import { FORM_COMPONENT_TYPE } from "../../enums";
import type { FormFooterComponent } from "../../types/forms";
import { Util } from "../../util";

//#endregion

//#region Define the component in class-style

@Component({
	components: { Button },
})
export default class FormFooter extends Vue {
	//#region Class properties will be component data

	@Prop() components?: FormFooterComponent[];
	@Prop({
		type: Boolean,
		default: true, // Set default to true if not passed
	})
	formValid?: boolean;

	//#endregion

	//#region Computed Properties

	get prefixClassName() {
		return this.$store.state.prefixClassName || "";
	}

	//#endregion

	//#region Main Methods

	decodeTags(content: string = "") {
		return content.replace(/&amp;/g, "&").replace(/&amp;/g, "&");
	}

	/**
	 * This method is used to create a computed property that returns the font style for the header text.
	 */
	get computedFontStyle() {
		return Util.getFontStyle(this.components, FORM_COMPONENT_TYPE.FooterText);
	}

	/**
	 * Determines whether the button should be hidden based on the provided component.
	 *
	 * @param {any} component - The component to check.
	 * @returns {boolean} - True if the button should be hidden, false otherwise.
	 */
	shouldHideButton(component) {
		try {
			if (
				component.type === "button" &&
				component.clickAction &&
				component.clickAction.settings &&
				component.clickAction.settings.isHidden
			) {
				return true;
			}
		} catch (ex) {
			//console.error('Error checking button visibility', error);
		}
		return false;
	}

	//#endregion
}

//#endregion
